import React from 'react'
// libs
import styled from 'styled-components'
// components
import { DialogTitle } from '@mui/material'
// views
import { CloseIcon } from 'components/UI/Icons'
// themes
import { colors } from 'themes/index'

const HeaderWrapper = styled(DialogTitle)`
  && {
    background: ${colors.darkBlue500};
    color: ${colors.white100};
    font-size: 22px;
    font-weight: bold;
    position: relative;
  }
`

interface IIncomingProps {
  children?: React.ReactNode
  handleClearClick?: () => void
}

const Header: React.FC<IIncomingProps> = ({ handleClearClick, children, ...rest }) => {
  return (
    <HeaderWrapper {...rest}>
      {children}
      {handleClearClick && <CloseIcon onClick={handleClearClick} />}
    </HeaderWrapper>
  )
}

export default Header
